import { render } from "./projetos-list-syncfusion.vue?vue&type=template&id=05b8df56&scoped=true"
import script from "./projetos-list-syncfusion.vue?vue&type=script&lang=js"
export * from "./projetos-list-syncfusion.vue?vue&type=script&lang=js"

import "./projetos-list-syncfusion.vue?vue&type=style&index=0&id=05b8df56&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b8df56"]])

export default __exports__